export default {
      id: "volume.sprite-usage",
      viewBox: "0 0 12 14",
      url: __webpack_public_path__ + "sprite.svg#volume.sprite-usage",
      toString: function () {
        return this.url;
      }
    }